import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { guidDateMnFun } from '../../../api/orgGuidAPI';
import { actDateMnFun } from '../../../api/orgActAPI';

export default async function handleSubmit(type, bookingData, packData, setAddBo) {
    if (!bookingData.people || bookingData.people <= 0) {
        toast.error('Please select no of people');
        return;
    }
    if (!bookingData.date) {
        toast.error('Please select date');
        return;
    }
    if (!bookingData.timeSlots || !bookingData.slotId) {
        toast.error('Please select time');
        return;
    }
    if (type === 'gu' && !bookingData.language) {
        toast.error('Please select language');
        return;
    }
    if (type === 'gu' && !bookingData.place) {
        toast.error('Please select place');
        return;
    }
    if (!bookingData.meetupLocation) {
        toast.error('Please select MeetUp point');
        return;
    }
    if (!bookingData.amountPaid.paid || bookingData.amountPaid.paid <= 0) {
        toast.error('Please enter the paid amount');
        return;
    }

    const isUserDetailsValid = bookingData.userDetails.every((user, index) => {
        if (!user.name || user.name.length < 3 || user.name.length > 30) {
            toast.error(`User ${index + 1}: Name is required`);
            return false;
        } else if (!user.age) {
            toast.error(`User ${index + 1}: Age is required`);
            return false;
        } else if (!user.sex || user.sex === 'Select') {
            toast.error(`User ${index + 1}: Sex is required`);
            return false;
        } else if (!user.phoneNumber) {
            toast.error(`User ${index + 1}: Phone Number is required`);
            return false;
        } else if (!user.emailId) {
            toast.error(`User ${index + 1}: Email ID is required`);
            return false;
        }
        return true;
    });

    if (!isUserDetailsValid) {
        return;
    }

    try {
        const baseData = {
            ...bookingData,
            startDate: bookingData.date,
            endDate: bookingData.date,
            organizerId: packData.organizerId,
            offerApplied: null,
            offerType: { name: '', code: '', type: 'percentage' },
            type
        };

        if (type === 'act') {
            baseData.amountPerSeat = bookingData.amountPaid.actual;
            baseData.totalSeats = bookingData.totalSeats.map((item) => ({
                name: item.name,
                prPerPr: Math.floor(item.total / item.count),
                count: item.count,
                qty: item.qty
            }));
        }

        if (type === 'gu') {
            baseData.totalSeats = Number(bookingData.people);
            baseData.seatsCount = Number(bookingData.people);
            baseData.place = bookingData.place;
        }

        let res;
        if (type === 'gu') {
            res = await guidDateMnFun(baseData);
        }
        if (type === 'act') {
            res = await actDateMnFun(baseData);
        }

        if (res.status === 200) {
            toast.success('Booked Successfully');
            setAddBo(false);
        }
    } catch (error) {
        errorHandle(error);
    }
}
